import assetPath from '/opt/actions-runner/_work/crate/crate/xinglets/startpage-logged-out/entry/src/recruiters-section/assets/julia-reichhofer-photo.webp';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')